<template>
    <v-container class="editing-caption-containter" :class="phraseClasses" :data-tooltip="modifiedData" fluid>
      <v-layout>
         <div v-if="$isMobile" contenteditable="false" class="mobile-play-container" @mousedown.stop.prevent="onTimeClicked(startTime, $event)" @click.stop.prevent>
          <div contenteditable="false" class="mobile-play-btn" v-bind:class="{'has-speaker':!!phrase.speaker}">
            <v-icon class="mdi-pause" v-bind:class="{'show':mediaPlaying}">{{ localIcons['mdi-pause'] }}</v-icon>
            <v-icon class="mdi-play" v-bind:class="{'show':!mediaPlaying}">{{ localIcons['mdi-play'] }}</v-icon>
          </div>
          </div>
        <div v-if="!$isMobile" class="nonselectable phrase-start" flex :contenteditable="'false'" @mouseover="(invalidType === 1 || invalidType === -1 || invalidType === 2) ? onHover(startTime,true) : null" @mouseleave="(invalidType === 1 || invalidType === -1 || invalidType === 2) ? onHover(startTime,false) : null">
          <a
            class="start-time"
            v-bind:class="{'invalid-time': (invalidType === -1 || invalidType === 2)}"
            @mouseup.stop="onTimeClicked(startTime, $event)"
            v-html="getDurationFormat(startTime)"
          ></a>
          <span
            class="end-time"
            v-bind:class="{'invalid-time': (invalidType === 1 || invalidType === 2)}"
            v-if="!$isMobile"
            v-html="getDurationFormat(endTime)"
          ></span>
          <div class="seperator speaker-time-seperator"></div>
          <div class="nonselectable fix-speaker-width speaker-label" style="color:gray">
              {{ phrase.speaker && phrase.speaker.value }}
            </div>
        </div>
        <div v-else class="nonselectable fix-speaker-width speaker-label" style="color:gray">
              {{  phrase.speaker && phrase.speaker.value }}
            </div>
        <div
         :contenteditable="readOnly === true || !active ? 'false': getContentEditableAvailableString"
         :data-container-position="active?phrase.id:null"
          ref="phrasecontentcontainer"
          class="phrase-content-container"
          @click="onPhraseMouseDown"
        >
          <div
            class="phrase-content"
            :class="{'nonselectable':!active}"
            :contenteditable="readOnly === true || !active ? 'false': getContentEditableAvailableString"
            :data-position="active?phrase.id:null"
            data-tutorial="phrase"
          >
            <word
              v-for="(word, index) in phrase.words"
              :key="word.id"
              :originalStartTime="word.startTime"
              :originalEndTime="word.endTime"
              :originalText="word.word"
              :confidence="word.confidence"
              :phraseIndex="phraseIndex"
              :wordIndex="index"
              :isVideoCut="!!word.isVideoCut"
              :isConfidence="false"
            ></word>
          </div>
        </div>
  
  
      </v-layout>
    </v-container>
  </template>
  
  <script>
import { mdiPlay, mdiPause} from '@mdi/js'
  import Word from "./Word";
  import transcriptHelper from "@/utils/transcriptHelper";
  export default {
    name: "PhraseComponent",
    props: ["phrase","phraseIndex", "duration", "speakers", "readOnly", "isConfidence","active","showModifiedTooltip","isLanguageSpace"],
    components: {
      Word
    },
    data() {
      return {
        mode: process.env.VUE_APP_MODE,
        isWithinViewPort: true,
        isCurrentPhraseActive: false,
        isDefaultSpeaker: true,
        newStartTime: null,
        newEndTime: null,
        wordIndex: 0,
        sliderStyle: "",
        closeOnClick: false,
        localActiveSpeaker: null,
        localIcons:{
          'mdi-play':mdiPlay,
          'mdi-pause':mdiPause
        },
        mediaPlaying: false,
        media: {}
      };
    },
    methods: {
      onHover(startTime, show){
  
        const elementId = startTime.toString().replace('.','-');
        if(show){
        document.getElementById(elementId).firstChild.style["visibility"] = "visible";
        document.getElementById(elementId).firstChild.style["opacity"] = "1";
        }
        else{
  
        document.getElementById(elementId).firstChild.style["visibility"] = "hidden";
        document.getElementById(elementId).firstChild.style["opacity"] = "0";
        }
      },
      onPhraseMouseDown(e){
        this.$emit('phrase-clicked',e)
      },
      onAddNewSpeaker(key, value) {
        const me = this;
        key = key || ((me.speakers && me.speakers.length || 0) + 1) + "";
        value = value || `${me.$lang.share.speaker} ${key}`;
  
        const newSpeaker = { key: key, value: value };
        me.$emit('update-speaker',newSpeaker)
      },
      // onSpeakerClicked() {
      //   const me = this;
      //   me.closeOnClick = false;
      //   if(me.speakers){
      //     me.speakers.forEach(function(s) {
      //       me.$refs["phrasespeaker" + s.key][0].reset();
      //     });
      //   }
      // },
      onSpeakerSelected(speaker) {
        const me = this;
        me.$emit("save-speaker", me.phrase.id, speaker);
        me.closeOnClick = true;
        me.localActiveSpeaker = speaker.value;
        me.$refs.speakerdropdown.isActive = false;
      },
      getDurationFormat(seconds) {
        const me = this;
        let splitList = [];
  
        splitList = transcriptHelper.getTimeFormat(me.duration, seconds, "second").split(".");
  
        return `${splitList[0]}<span class="milliseconds">.${splitList[1]}</span>`;
      },
      onTimeClicked(seconds) {
        const me = this;
  
        if(me.$isMobile){
  
          if(me.mediaPlaying){
            me.onPause();
          }
          else{
            me.$emit("set-time", seconds, me.phrase.endTime, null, null, true);
            me.$nextTick(()=>{
              setTimeout(function(){
                me.mediaPlaying = false;
              },me.phraseDurationMs);
              me.mediaPlaying = true;
            })
          }
        }
        else{
          me.$emit("set-time", seconds, me.phrase.endTime, true, null, null, true);
        }
      },
      onPlay(){
        const me = this;
        me.mediaPlaying = true;
        me.$emit("play-media");
      },
      onPause(){
        const me = this;
        me.mediaPlaying = false;
        me.$emit("pause-media");
      },
      onNoteOpen(){
        const me = this;
        if(me.phrase && !me.readOnly){
          me.$emit('open-notes',me.phrase);
        }
      }
      // onKeyup(e){
      //   const me = this;
      //   console.log('finally')
      //   if(textHelper.isDeletionKey(e)){
      //     console.log('is deletion key up')
      //     clearTimeout(timer);
      //     timer = setTimeout( me.refresh , 200 )
      //   }
      // },
      // refresh() { 
      //   const me = this
      //   console.log('refresh')
      //   me.updatePhraseEditStatus()
      // },
      // updatePhraseEditStatus(e){
      //   const me = this;
  
      //   console.log('refresh 2')
      //   // this means it is inactive phrase element or invalid phrase element
      //   if(!me.$refs.phrasecontentcontainer || me.$refs.phrasecontentcontainer.contentEditable === 'false') {
      //     return;
      //   }
      //   else {
      //     const phraseContentDom = me.$refs.phrasecontentcontainer.querySelector('.phrase-content');
      //     let errMessage = '';
  
  
      //     if(!phraseContentDom){
      //       console.log('ERROR HERE')
      //       //  me.$el.parentElement.parentElement.remove()
      //         errMessage = 'missing phrase-content=='+ me.$refs.phrasecontentcontainer.outerHTML+'-----------------------------'+(e && e.detail);
      //         me.$emit('test', {errorMessage:errMessage, id:me.$refs.phrasecontentcontainer.getAttribute('data-container-position'), forceRefresh:true})
      //         return;
      //     }
      //     else if(phraseContentDom.innerHTML === '<br>'){
      //       //  me.$el.parentElement.parentElement.remove()
      //         errMessage = 'phrase-content inner content br =='+ me.$refs.phrasecontentcontainer.outerHTML+'-----------------------------'+(e && e.detail);
      //         me.$emit('test', {errorMessage:errMessage, id:me.$refs.phrasecontentcontainer.getAttribute('data-container-position'), forceRefresh:true})
      //         return;
  
      //     }
      //     else if(!phraseContentDom.innerHTML){
      //       console.log('ERROR HERE')
      //       //  me.$el.parentElement.parentElement.remove()
      //         errMessage = 'missing phrase-content inner content=='+ me.$refs.phrasecontentcontainer.outerHTML+'-----------------------------'+(e && e.detail);
      //         me.$emit('test', {errorMessage:errMessage, id:me.$refs.phrasecontentcontainer.getAttribute('data-container-position'), forceRefresh:true})
      //         return;
  
      //     }
      //   }
      // }
      // updatePhraseEditStatus(){
      //   const me = this;
      //   if(me.$refs.phrasecontentcontainer){
      //     const phraseContentDom = me.$refs.phrasecontentcontainer.querySelector('.phrase-content');
      //     if(!phraseContentDom){
      //       const newDate = new Date();
      //       const currentTicks = newDate.getTime();
      //       me.$mediaConnection.logError(me.$route.params.id+'_'+currentTicks, 'missing phrase-content');
      //       me.$emit('test', 'missing phrase-content')
      //       return;
      //     }
  
      //     var style = window.getComputedStyle(me.$refs.phrasecontentcontainer.closest('.vue-recycle-scroller__item-view'));
      //     //var matrix = new WebKitCSSMatrix(style.webkitTransform);
      //     var matrix = new WebKitCSSMatrix(style.transform || style.webkitTransform);
      //     me.isWithinViewPort = matrix.m42 !== -9999;
  
        
  
      //     if(!me.isWithinViewPort){
      //       phraseContentDom.classList.add('nonselectable');
      //     //  me.$refs.phrasecontentcontainer.classList.add('phrase-hide');
      //     }
      //     else{
      //       phraseContentDom.classList.remove('nonselectable');
      //     //  me.$refs.phrasecontentcontainer.classList.remove('phrase-hide');
      //     }
      //   }
      //   else{
      //     me.isWithinViewPort = false;
      //   }
      // }
      //  invalidPhraseIds: state => state.invalidPhraseIds
    },
    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    computed: {
      // ...storeModules.editSession.mapState({
      //   media: state => state.media,
      //   invalidPhraseIds: state => state.invalidPhraseIds,
      //   focusId: state => state.focusId,
      // }),
      isFocused(){
        const me = this;
     //   var selection = window.getSelection();  
  //var container = selection.anchorNode; 
        return me.$refs.phrasecontentcontainer && document.activeElement === me.$refs.phrasecontentcontainer.$el
      },
      wordCount(){
        const me = this;
        if(!me.phrase.transcript) return 0;
  
        return me.phrase.words.reduce(function(sum, word){
          if(!word.isVideoCut){
            sum+= (word.word ? word.word.length : 0);
          }
          return sum;
        }, 0);
  
        //return me.phrase.transcript.length;
        
        // if(me.isLanguageSpace){
        //   return me.phrase.transcript.split(' ').filter(function(i){return i;}).length;
        // }
        // else{
        //   return me.phrase.transcript.length;
        // }
      },  
      getContentEditableAvailableString(){
        const me = this;
        return me.$isBrowserSupported ? 'plaintext-only' : 'true'
      },
      invalidType(){
       // const me = this;
        return null;
      //  return me.invalidPhraseIds[me.phrase.id];
      },
      // isInvalidPhrase(){
      //   const me = this;
      //   return !!me.invalidPhraseIds[me.phrase.id];
      // },
      // isLanguageSpace(){
      //   const me = this;
      //   return mediaUtils.isLanguageSpace(me.$lang.getLang()); 
      // },
      modifiedData(){
        const me = this;
        if(me.phrase && me.phrase.note){
          if(me.phrase.noteAuthor){
            return me.phrase.note +"\r\n\r\n" + me.phrase.noteAuthor;
          }
            return me.phrase.note;
        }
  
        return '';
      },
      // modifiedData(){
      //   const me = this;
      //   if(me.phrase && me.phrase.modified){
  
      //     let milliseconds = transcriptHelper.getMillis(me.phrase.modified);
      //     if(!milliseconds){
      //       milliseconds = moment().valueOf(me.phrase.modified);
      //     }
  
      //     if(me.isLanguageSpace){
      //       return `${me.$lang.editing.edited_on} ${mediaUtils.getFriendlyTime(me.$lang, milliseconds)} by ${me.phrase.modifiedBy || ''}`;
      //     }
  
      //     return `${me.phrase.modifiedBy || ''} ${mediaUtils.getFriendlyTime(me.$lang, milliseconds)}${me.$lang.editing.edited_on}`;
      //   }
  
      //   return '';
      // },

/* eslint-disable vue/no-side-effects-in-computed-properties */
      activeSpeaker() {
        const me = this;
  
        if (me.speakers && me.phrase.speaker) {
          me.isDefaultSpeaker = false;
          return me.speakers.find(function(e) {
            return e.key === me.phrase.speaker.key;
          }).value;
        }
        else if(me.localActiveSpeaker){
          return me.localActiveSpeaker;
        }
  
        me.isDefaultSpeaker = true;
        return `(${me.$lang.share.speaker})`;
      },
      /* eslint-enable vue/no-side-effects-in-computed-properties */
      startTime() {
        const me = this;
        if (me.newStartTime !== null) {
          return me.newStartTime;
        }
  
        return me.phrase.startTime;
      },
      endTime() {
        const me = this;
        if (me.newEndTime !== null) {
          return me.newEndTime;
        }
  
        return me.phrase.endTime;
      },
      phraseDurationMs(){
        const me = this;
        return (me.endTime - me.startTime) * 1000;
      },
      phraseClasses() {
        const me = this;
        let classes = "";
  
        classes += (me.phrase.note)? "modified-tooltip " : "";
        classes += me.phrase.modified ? "modified " : "";
     //   classes += me.isCurrentPhraseActive ? "active" : "";
        classes += (me.focusId === me.phrase.id) ? 'active':'';
        return classes;
      }
      // phraseClasses() {
      //   const me = this;
      //   let classes = "";
  
      //   classes += (me.phrase.modified && me.showModifiedTooltip)? "modified-tooltip " : "";
      //   classes += me.phrase.modified ? "modified " : "";
      //   classes += me.isCurrentPhraseActive ? "active" : "";
      //   return classes;
      // }
    },
    // mounted(){
    //   const me = this;
    //   let timer = null;
  
    //   // refresh after scroll 
    //   const refresh = function () { 
    //     console.log('refresh')
    //       me.updatePhraseEditStatus();
    //   };
  
    //     // me.$el.addEventListener('keypress', function(){
    //     //   console.log('hi')
    //     // })
  
    //   // window.addEventListener('scroll', function(e) {
    //   //   clearTimeout(timer);
    //   //   timer = setTimeout( refresh , 200 );
    //   // });
  
    //   // window.addEventListener('keyup', function(e) {
    //   //   if(textHelper.isDeletionKey(e)){
    //   //    // console.log('is deletion key up')
    //   //     clearTimeout(timer);
    //   //     timer = setTimeout( refresh , 500 );
    //   //   }
    //   // });
  
    //   // Listen for the event.
    //   //    window.addEventListener(me.phrase.id, function (e) { 
    //   //   me.updatePhraseEditStatus(e);
    //   //  }, false);
  
    //   // window.addEventListener('updatephrasestatus', function (e) { 
    //   //   me.updatePhraseEditStatus(e);
    //   //  }, false);
  
  
    // }
  };
  </script>
  
  <style>
  .editing-caption-containter{
    text-align: left;
  }
  .editing-caption-containter.modified-tooltip:after {
    opacity:0;
    content: attr(data-tooltip);
    width: 130px;
    min-height: 30px;
    display:block;
    margin-left:0px;
    margin-top:-10px;
    transition: all 100ms ease-in;
    background:white;
    border-radius:0px 10px 10px 10px;
    padding:5px;
    right:-140px;
    color:gray;
    user-select: none;
    position:absolute;
    font-size:14px;
    -webkit-box-shadow: 0 1px 4px rgb(1 1 1 / 15%);
    box-shadow: 0 1px 4px rgb(1 1 1 / 15%);
    line-height: 15px;
  }
  
  .editing-caption-containter.modified-tooltip:hover:after {
    opacity: 1;
    font-size:14px;
    line-height: 15px;
  }
  
  .editing-caption-containter.active .phrase-content-container{
    border-bottom: 1px solid lightgray;
    -webkit-box-shadow: 0 4px 6px -6px lightgray;
    -moz-box-shadow: 0 4px 6px -6px lightgray;
    box-shadow: 0 4px 6px -6px lightgray;
  }
  
  
  /* div.modified-indicator:before {
    opacity:0;
    content: attr(data-tooltip);
    width: 130px;
    min-height: 30px;
    display:block;
    font-size:14px;
    margin-left:-139px;
    margin-top:-10px;
    transition: all 200ms ease-in;
    background:white;
    border-radius:5px 0px 0px 5px;
    padding:5px;
    color:gray;
    user-select: none;
  
  -webkit-box-shadow: 0 1px 4px rgb(1 1 1 / 15%);
      box-shadow: 0 1px 4px rgb(1 1 1 / 15%);
  }
  div.modified-indicator.active {
    background:#3bd5b1;
    cursor: pointer;
  }
  div.modified-indicator.active:hover:before {
    opacity: 1;
  }
  .modified-indicator{
    width:10px;
    height:10px;
    border:1px solid lightgray;
    border-radius: 50%;
    position: absolute;
    top:8px;
    display:inline-block;
    -webkit-user-select: none;  
    -moz-user-select: none;    
    -ms-user-select: none;    
     user-select: none!important; 
  } */
  
  
  
  
  .milliseconds {
    font-size: 10px;
    color: gray;
  }
  
  .blur-text {
    color: transparent;
  }
  
  .speaker-arrow.v-icon {
    position: absolute;
    font-size: 16px;
    top: 19px;
    color: #3bd5b1;
    left: 125px;
  }
  
  .speaker-dropdown:hover .speaker-arrow.v-icon {
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
  }
  
  .speaker-dropdown button {
    outline: none;
  }
  
  .speaker-dropdown:hover button {
    background: #e2f8f2;
    border-radius: 2px;
  }
  
  .dark .speaker-dropdown:hover button {
    background: #3A3B3C;
  }
  
  
  .speaker-dropdown.dropdown {
    display: inline-flex;
    position: relative;
    width: calc(100% - 20px);
    text-align: right;
    font-size: 12px;
    bottom: 12px;
    padding-top: 15px;
    user-select: none;
  }
  
  .speaker-dropdown .dropdown-menu {
    left: 0;
    min-width: 190px;
    position: absolute;
    top: 0px;
    padding: 0px;
    left: -200px;
  }
  
  .speaker-dropdown .dropdown-item {
    padding: 0px;
    padding-right: 0px !important;
  }
  
  .speaker-dropdown .dropdown-item input {
    width: calc(100% - 22px);
    padding: 3px;
  }
  
  .speaker-dropdown .dropdown-content {
    padding-bottom: 0px;
  }
  
  .speaker-active-value {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 110px;
    display: inline-block;
    text-align: right;
    color: darkslategray;
  }
  
  .speaker-active-value.default {
    color: #a2aab0;
  }
  
  .seperator.speaker-time-seperator {
    position: absolute;
    width: 110px;
    top: 12px;
  }
  
  .start-time {
    position: absolute;
  }
  
  .end-time{
          position: absolute;
      top: 0px!important;
      left: 77px;
      font-size: 10px;
      color: gray;
  }
  
  .speaker-label {
    width: calc(100% - 22px);
    height: 27px;
    padding: 3px;
  }
  
  .speaker-dropdown .v-icon {
    font-size: 15px;
  }
  
  .speaker-dropdown .speaker-edit {
    width: 22px;
    height: 26px !important;
    min-width: 22px !important;
    padding: 0 !important;
    position: absolute;
    top: 0;
    right: 0;
  }
  
  .speaker-dropdown .v-icon:hover {
    background: #e2f8f2;
  }
  
  .dark .speaker-dropdown .dropdown-menu{
    border:1px black solid;
  }
  
  .dark .speaker-dropdown a.dropdown-item{
    border-radius: 0px!important;
    border-bottom: 1px solid gray;
  }
  
  .dark .speaker-dropdown a.dropdown-item:hover{
    background: gray!important;
  }
  
  /* .speaker-dropdown .dark a.dropdown-item,
  .speaker-dropdown a.dropdown-item{
    border-radius: 0px!important;
    border-bottom: 1px solid gray;
  } */
  
  .v-icon.fa-check{
    opacity: 1;
  }
  
  .mobile-play-container{
    width: 60px;
    height:100%;
     user-select: none;
     -webkit-user-select: none;
     position:absolute;
     z-index:1;
     left:0px;
  }
  
  .mobile-play-btn{
    background:#45d4be;
    z-index: 1;
    width:30px;
    height: 30px;
    margin-left: 10px;
    margin-right: 20px;
    border-radius: 50%;
     user-select: none;
     -webkit-user-select: none;
     position:relative;
  }

  .has-speaker{
    margin-top:6px;
  }
  
  .editing-caption-containter .mdi-pause,
  .editing-caption-containter .mdi-play{
    font-size: 10px;
    /* padding: 7px; */
    margin-left: calc(50% - 12px);
    position: absolute;
    /* top: calc(50% - 6px); */
    display: none;
    margin-top: 2px;
  }
  
  .mobile-play-btn .show{
          color:white;
    display:block;
  }
  
  span.video-cut{
    color: #ff365b!important;
    opacity: 0.6;
    text-decoration: line-through
  }
  
  
  
  .dark .editing-caption-containter.modified-tooltip:before {
    color:white;
    background:#3a3b3c;
  }
  
  .dark .editing-caption-containter.modified-tooltip:after {
    color:white;
    background:#3a3b3c;
  }
  
  
  @media (max-width: 992px) {
    .speaker-label {
      width: auto;
      height: auto;
      padding: 3px;
      color: gray;
    position: absolute;
    left: 0px;
    top: -7px;
    font-size: 14px;
    font-weight: bold;
    }
  }
  </style>
  <style scoped>
  
  
  .editing-caption-containter span.invalid-time,
  .editing-caption-containter a.invalid-time{
    /* background:#faeea8; */
    padding: 0px 2px;
    border-radius: 3px;
    color:darkorange!important;
  }
  .new-translation {
    padding: 3px;
  }
  .editing-caption-containter {
    padding-left: 0px;
    padding-right: 0px;
    border-left: 2px solid transparent;
    margin: 5px 0px;
    padding: 10px 0px;
    display: flex;
    flex-wrap: nowrap;
    position: relative;
    font-size: 18px;
    color: black;
    letter-spacing: 0.5px;
    max-width: 100%;
  }
  
  .editing-caption-containter.modified {
    border-color: #3bd5b1;
  }
  
  .editing-caption-containter a {
    color: #0062ff !important;
    font-size: 14px;
    top: -8px;
    font-weight: 400;
    /* z-index: 4; */
  }
  
  
  .phrase-end,
  .phrase-start {
    max-width: 100px;
    min-width: 100px;
    padding: 0px 10px;
    height: 30px;
  }
  
  .phrase-start {
    max-width: 150px;
    min-width: 150px;
  }
  
  .phrase-end .end-time {
    cursor: default !important;
  }
  
  .phrase-content-container {
    width: calc(100% - 200px);
    border-bottom: 1px lightgray dashed;
      -webkit-user-select: text;
      user-select: text;
      background:transparent;
      display:inline-block; 
  
        -webkit-transition: all 200ms ease-in-out;
    -moz-transition: all 200ms ease-in-out;
    -o-transition: all 200ms ease-in-out;
    transition: all 200ms ease-in-out;
  } 
  .phrase-content {
      -webkit-user-select: text;
      user-select: text;
      display:inline-block;
  }
  /* .phrase-content {
    width: calc(100% - 200px);
      -webkit-user-select: text;
      user-select: text;
      display:inline-block;
  
    border-bottom: 1px lightgray dashed;
  
        -webkit-transition: all 200ms ease-in-out;
    -moz-transition: all 200ms ease-in-out;
    -o-transition: all 200ms ease-in-out;
    transition: all 200ms ease-in-out;
  } */
  
  .phrase-hide{
    display: none;;
  }
  
  
  .phrase-modified {
    position: absolute;
    right: 0px;
    bottom: 0px;
    font-size: 10px;
    color: gray;
    font-style: italic;
  }
  
  .phrase-modifiedBy {
    margin-right: 5px;
    font-weight: bold;
    font-style: normal;
  }
  
  .word-count{
    opacity: 0;
    -moz-user-select: none; 
    -webkit-user-select: none; 
    -ms-user-select:none; 
    user-select:none;
    -o-user-select:none;
    color: #45D4BE;
      font-size: 12px;
      color: #31889e;
      vertical-align: bottom;
    transform:translateX(-10px);
      /* display: contents; */
      /* height: 10px; */
      position: absolute;
      right: 34px;
      /* top: 15px; */
      bottom: 15px;
  
    -webkit-transition: all 200ms ease-in-out;
    -moz-transition: all 200ms ease-in-out;
    -o-transition: all 200ms ease-in-out;
    transition: all 200ms ease-in-out;
  }
  
  .word-count.visible{
    transform:translateX(0px);
    opacity: 1;
  }
  
  .notes{
      position: absolute;
      right: 0px;
      /* top:10px!important; */
      border: 1px dashed lightgray;
      color: transparent!important;
      height: 30px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      cursor: pointer;
      width:30px;
      display: block;
      user-select: none;
      /* pointer-events: none; */
  }
  
  .notes.has-notes{
    background-color: #45d4be;
    opacity: 0.5;
  }
  
  
  .notes.has-notes.disable-notes{
    background-color: lightgray;
    background: lightgray;
    cursor: default;
  }
  
  /* .dark a.start-time.invalid-time,
  .dark a.end-time.invalid-time{
    color:black!important;
  }
  
  
  .dark .invalid-time{
    background:rgb(235, 183, 51);
  } */
  
  /* .dark .editing-caption-containter a {
    color: white !important;
  } */
  
  .dark .word-count{
    color: #20F7C4!important;
  }
  
  .dark .notes{
      color: transparent!important;
      border: 1px dashed #20F7C4;
  }
  .dark .notes.has-notes{
    opacity: 1;
  }
  @media (max-width: 992px) {
  
  .speaker-active-value {
    width:auto;
  }
  
  .phrase-start {
      max-width: 100px!important;
      min-width: 100px!important;
  }
  .phrase-content-container {
      width: calc(100% - 100px)!important;
  }
  
  /* .phrase-content {
      width: calc(100% - 100px)!important;
  } */
  
  .speaker-arrow.v-icon {
      left: 65px!important;
  }
  
  .seperator.speaker-time-seperator {
      width: 80px!important;
  }
  }
  @media (max-width: 600px) {
  .phrase-start {
      padding:0px;
      
  }
  .speaker-active-value {
  display: block!important;
      text-align: left;
  }
  
  .editing-caption-containter{
    margin:0px;
    padding-top:10px;
    padding-left:60px;
  }
  /* .phrase-content {
      width: calc(100% - 30px)!important;
  } */
  .phrase-content-container {
      width: calc(100% - 30px)!important;
  }
  }
  
  </style>
  